/**
 * Convert an unknown error into a plain object that survives
 * `JSON.stringify` and structured cloning (Error instances normally don't
 * fully survive `JSON.stringify`, since `name`/`message`/`stack` are
 * non-enumerable). Useful when stuffing an error into `react-router`
 * location state or a `console.log` payload that needs to remain readable in
 * the Sentry replay.
 *
 * Kept dependency-free so it can be imported from anywhere - including the
 * low-level `httpService` - without creating circular imports.
 */
export const serializeError = (error: unknown): Record<string, unknown> => {
    if (error instanceof Error) {
        return {
            name: error.name,
            message: error.message,
            stack: error.stack
        }
    }
    if (error && typeof error === 'object') {
        try {
            return { value: JSON.parse(JSON.stringify(error)) }
        } catch {
            return { value: String(error) }
        }
    }
    return { value: String(error) }
}
